import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Guard der Routen nur in Non-Production-Umgebungen zulaesst.
 * Schuetzt Dev-Only-Routen (z.B. /dev-login) vor versehentlichem Zugriff in Production.
 *
 * Bei production === true → Redirect zu /unauthorized.
 */
export const nonProductionGuard: CanActivateFn = () => {
  if (environment.production) {
    inject(Router).navigate(['/unauthorized']);
    return false;
  }
  return true;
};
